import {
  SMILE_HOME_ROUTE,
  SMILE_SIGNUP_ROUTE,
  SMILE_SIGNUP_SUCCESS_ROUTE,
  SMILE_SIGNIN_ROUTE,
  SMILE_PASSWORD_FORGOTTEN_ROUTE,
  HYBRIDGE_HOME_ROUTE,
  HYBRIDGE_SIGNUP_ROUTE,
  HYBRIDGE_SIGNUP_SUCCESS_ROUTE,
  HYBRIDGE_SIGNIN_ROUTE,
  HYBRIDGE_PASSWORD_FORGOTTEN_ROUTE,
} from "src/utils/constants/routes";

export const IS_HYBRIDGE = process.env.NEXT_PUBLIC_APP === "hybridge";
export const APP_HOME_ROUTE = IS_HYBRIDGE ? HYBRIDGE_HOME_ROUTE : SMILE_HOME_ROUTE;
export const APP_SIGNUP_ROUTE = IS_HYBRIDGE ? HYBRIDGE_SIGNUP_ROUTE : SMILE_SIGNUP_ROUTE;
export const APP_SIGNUP_SUCCESS_ROUTE = IS_HYBRIDGE ? HYBRIDGE_SIGNUP_SUCCESS_ROUTE : SMILE_SIGNUP_SUCCESS_ROUTE;
export const APP_SIGNIN_ROUTE = IS_HYBRIDGE ? HYBRIDGE_SIGNIN_ROUTE : SMILE_SIGNIN_ROUTE;
export const APP_PASSWORD_FORGOTTEN_ROUTE = IS_HYBRIDGE
  ? HYBRIDGE_PASSWORD_FORGOTTEN_ROUTE
  : SMILE_PASSWORD_FORGOTTEN_ROUTE;
